// extracted by mini-css-extract-plugin
export var chevronIcon = "_63-2";
export var teamName = "_63-1";
export var teamSwitcherButton = "_63-0";